"use client";

import { BadgeQuestionMark, ChevronDown } from "lucide-react";
import Accordion from "@/components/ui/accordion";
import Title from "@/components/Title";
import { ADS_FAQ_ID } from "@/helpers/ads";
import AdsHashScroll from "./_hashScroll";

/** سوالات متداول ادز (ads-faq): ویجت تکرارپذیر با فیلدهای `question` و `answer`. */
export default function AdsFaq({ fields }) {
    const items = (fields?.repeatable_fields || []).filter((item) => item?.question);
    if (!items.length) return null;

    const section_title = fields?.section_title;

    return (
        <section id={ADS_FAQ_ID} className="container scroll-mt-[calc(var(--header-height,130px)+16px)]">
            <AdsHashScroll id={ADS_FAQ_ID} />
            {section_title?.title && (
                <div className="mb-2 flex items-center gap-2 text-jmt-main">
                    <BadgeQuestionMark size={26} className="shrink-0" aria-hidden="true" />
                    <Title type={section_title?.type} className="text-lg font-bold leading-7">
                        {section_title.title}
                    </Title>
                </div>
            )}

            <div className="lg:pr-[34px]">
                {items.map((item, index) => (
                    <Accordion
                        key={item?.id || index}
                        title={item.question}
                        className="border-b border-jmt-neutral-200"
                        headerClassName="flex w-full items-center justify-between gap-1 py-4 text-start"
                        titleClassName="text-base font-bold leading-6 text-jmt-main"
                        iconClassname="text-jmt-neutral-900"
                        icon={<ChevronDown size={22} />}
                        contentClassName="whitespace-pre-line pb-4 text-sm leading-[26px] text-jmt-neutral-600">
                        {item.answer}
                    </Accordion>
                ))}
            </div>
        </section>
    );
}
